import React, { Component } from "react";
import {Link,NavLink}               from "react-router-dom";

//Import Image
import logoMain             from "../../assets/images/logo.jpeg"
import secondLogo           from "../../assets/images/logo-2.jpeg"

class Headers extends Component {
    scrollTop()
    {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    render() {
        return (
            <>
                {/* =============== Topbar area start =============== */}
            <div className="topbar-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-5 tob-contact-row">
                            <div className="topbar-contact">
                                <ul>
                                    <li>
                                        <i className="bx bxs-phone" />
                                        <a href="tel:+917604912350">+971 50 4717658</a>
                                    </li>

                                    <li>
                                        <i className="bx bxs-envelope" />
                                        <a href="mailto:contact@classifytours.com">jagtechnicalservice@gmail.com</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 col-6">

                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-6 col-6">

                        </div>
                    </div>
                </div>
            </div>

            {/* =============== Topbar area end =============== */}


            {/* ===============  header area start =============== */}
            <header>
                <div className="header-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-2 col-md-12 col-sm-12 col-xs-12">
                                <div className="navbar-wrap">
                                    <div className="logo d-flex justify-content-between">
                                    <h2>J.A.G</h2>
                                    </div>
                                    <div className="navbar-icons">

                                        <div className="user-dropdown-icon">


                                        </div>
                                        <div className="mobile-menu d-flex ">
                                            <div className="top-search-bar m-0 d-block d-xl-none">
                                            </div>
                                            <Link to={"#"} className="hamburger d-block d-xl-none">
                                                <span className="h-top" />
                                                <span className="h-middle" />
                                                <span className="h-bottom" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                                <nav className="main-nav">
                                    <div className="navber-logo-sm">
                                      <h2 style={{color:'white'}}>J.A.G</h2>
                                    </div>
                                    <ul>
                                          <li>
                                        <NavLink  activeClassName="active" to={`${process.env.PUBLIC_URL}`} onClick={this.scrollTop} >Home</NavLink >
                                        </li>


                                        <li>
                                            <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/aboutus`} onClick={this.scrollTop} >About Us</NavLink>
                                        </li>

                                        <li className="has-child-menu">
                                            <Link to={"#"}>Products/Projects</Link>
                                            <i className="fl flaticon-plus">+</i>
                                            <ul className="sub-menu">
                                            <li>
                                                <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/product1/Product1`} className="sub-item" onClick={this.scrollTop}>Auto Shot Blast Eqiupment/Dust collector</NavLink>
                                            </li>
                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/product2/Product2`} className="sub-item" onClick={this.scrollTop}>Handling Equipment</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/product3/Product3`} className="sub-item" onClick={this.scrollTop}>Steel Fabrication</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/product4/Product4`} className="sub-item" onClick={this.scrollTop}>Engineering Jobs</NavLink>
                                                </li>

                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/product5/Product5`} className="sub-item" onClick={this.scrollTop}>Pipeline Works</NavLink>
                                                </li>

                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/product7/Product7`} className="sub-item" onClick={this.scrollTop}>Machining Works</NavLink>
                                                </li>


                                            </ul>
                                        </li>

                                        <li className="has-child-menu">
                                            <Link to={"#"}>Services</Link>
                                            <i className="fl flaticon-plus">+</i>
                                            <ul className="sub-menu">
                                            <li>
                                                <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/service1/Service1`} className="sub-item" onClick={this.scrollTop}>Equipment Maintenance/AMC</NavLink>
                                            </li>
                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/service2/Service2`} className="sub-item" onClick={this.scrollTop}>Machineries Erection &amp; Commissioning</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/service3/Service3`} className="sub-item" onClick={this.scrollTop}>Equipment/Machineries Refurbishment and Relocation</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/service4/Service4`} className="sub-item" onClick={this.scrollTop}>Pre-owned Equipment</NavLink>
                                                </li>


                                            </ul>
                                        </li>



                                        <li>
                                            <NavLink activeClassName="active" to={`${process.env.PUBLIC_URL}/contact`} onClick={this.scrollTop} >Contact Us</NavLink>
                                        </li>
                                    </ul>
                                    <div className="navbar-icons-2">

                                        <div className="user-dropdown-icon">

                                            <div className="account-dropdown">
                                                <ul>
                                                    <li className="account-el">
                                                        <i className="bx bx-user-pin" />
                                                        <Link to={`#`} >Sign in</Link>
                                                    </li>
                                                    <li className="account-el">
                                                        <i className="bx bxs-user-account" />
                                                        <Link to={`#`} >My Account</Link>
                                                    </li>
                                                    <li className="account-el">
                                                        <i className="bx bx-extension" />
                                                        <Link to={`#`} >Settings</Link>
                                                    </li>
                                                    <li className="account-el">
                                                        <i className="bx bx-log-in-circle" />
                                                        <Link to={`#`} >Log out</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sidebar-contact">
                                        <ul>
                                            <li className="sidebar-single-contact"><i className="bx bxs-phone" />

                                                <Link to={`tel:+971 50 4717658`} >+971 50 4717658 (24/7)</Link>
                                            </li>
                                            <li className="sidebar-single-contact"><i className="bx bxs-envelope" />
                                                <Link to={`mailto:jagtechnicalservice@gmail.com`} >jagtechnicalservice@gmail.com</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <form>
                        <div className="main-searchbar">
                            <div className="searchbar-close">
                                <i className="bx bx-x" />
                            </div>
                            <input type="text" placeholder="Search Here......" />
                            <div className="searchbar-icon">
                                <i className="bx bx-search" />
                            </div>
                        </div>
                    </form>

                </div>
            </header>
            {/* ===============  header area end =============== */}
            </>
        );
    }
}

export default Headers;
